import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const { user, setAuthOpen } = useAuth();
  const [ids, setIds] = useState(new Set());

  const refresh = () => {
    if (!user) { setIds(new Set()); return; }
    api.get("/wishlist").then((r) => setIds(new Set(r.data.map((t) => t.id)))).catch(() => {});
  };

  useEffect(refresh, [user]); // eslint-disable-line

  const toggle = async (track) => {
    if (!user) { setAuthOpen(true); return; }
    const inWl = ids.has(track.id);
    try {
      if (inWl) {
        await api.delete(`/wishlist/${track.id}`);
        setIds((s) => { const n = new Set(s); n.delete(track.id); return n; });
        toast("Removed from wishlist");
      } else {
        await api.post(`/wishlist/${track.id}`);
        setIds((s) => new Set(s).add(track.id));
        toast.success("Saved to wishlist");
      }
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not update wishlist");
    }
  };

  return (
    <WishlistContext.Provider value={{ ids, toggle, refresh, isWishlisted: (id) => ids.has(id) }}>
      {children}
    </WishlistContext.Provider>
  );
};
